var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArsUnauthorized(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.43a9.214 9.214 0 0 0 2.841 6.675 9.876 9.876 0 0 0 13.682 0 9.218 9.218 0 0 0 2.841-6.676 9.213 9.213 0 0 0-2.84-6.675 9.875 9.875 0 0 0-13.683 0A9.216 9.216 0 0 0 0 9.429zm3.614 5.875a8.113 8.113 0 0 1-2.51-5.876 8.11 8.11 0 0 1 2.123-5.49l12.11 11.752a8.772 8.772 0 0 1-11.723-.386zM15.75 3.553a8.112 8.112 0 0 1 2.51 5.876 8.11 8.11 0 0 1-2.123 5.49L4.027 3.166a8.773 8.773 0 0 1 11.723.386z",
    fill: "#EF8F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArsUnauthorized);
export default __webpack_public_path__ + "static/media/arsUnauthorized.ba13a19b69127b0ccb0952d86fd2cb1b.svg";
export { ForwardRef as ReactComponent };